module.exports = __webpack_public_path__ + "img/1.a7a1d795.jpg";